<template>
  <div class="bet-header font-bold">
    <div
      class="bet-header-top"
      :class="`width-${betStyle.betIdWidth}`">
      <p
        class="bet-id text-center"
        :class="{ 'colored': betStyle.betIdColored }">
        {{ betDisplayId }}
      </p>
      <p
        class="bet-name text-upper"
        :class="`text-${betStyle.betNamePosition}`">
        {{ betName }}
      </p>
    </div>
    <div class="bet-header-bottom text-center text-upper">
      <p
        class="outcome-name"
        :class="`outcome-${outcomes.length}`"
        v-for="outcome in outcomes"
        :key="outcome.id">
        {{ outcome.nameShort }}
      </p>
    </div>
  </div>
</template>

<script>
import { sortBy, take } from 'lodash';
import mapBetName from '@/filters/betHeaderMapper';

export default {
  name: 'SportHeaderBet',
  props: {
    bet: {
      required: true,
      type: Object,
    },
    betStyle: {
      required: false,
      type: Object,
      default: () => ({
        betIdColored: false,
        betIdWidth: 'normal',
        betNamePosition: 'center',
      }),
      validator: style => ['normal', 'large'].indexOf(style.betIdWidth) > -1
        && ['center', 'left'].indexOf(style.betNamePosition) > -1,
    },
    special: {
      required: false,
      type: [String, Boolean],
      default: false,
    },
  },
  data() {
    return {
      maxOutcomes: 3,
    };
  },
  computed: {
    betDisplayId() {
      return this.bet.idDisplay || '-';
    },
    specialMarket() {
      return this.$store.getters.specialMarkets.includes(this.bet.id);
    },
    betName() {
      if (!this.bet.nameShort) return '-';
      return mapBetName(
        this.bet.nameShort,
        this.special,
        this.$router.currentRoute.name,
        this.outcomes.length,
        this.specialMarket,
      );
    },
    outcomes() {
      const outcomes = sortBy(this.bet.outcomes, 'position');
      return take(outcomes, this.maxOutcomes);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.bet-header {
  overflow: hidden;
  height: 5vh;
}

.bet-header-top,
.bet-header-bottom {
  position: relative;
  float: left;
  width: 100%;
}

.bet-header-top {
  height: $sport-header-bet-top-height;
  line-height: $sport-header-bet-top-height;
  background-color: $sport-header-bet-top-color-back;
  font-size: 0.6875rem;
  white-space: nowrap;

  .bet-id {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: $sport-header-bet-top-id-width;
    padding-left: 2px;
    color: $sport-header-bet-top-id-color;
    background-color: $sport-header-bet-top-id-color-back;
    border-top-right-radius: $sport-header-bet-top-id-border-radius;
    border-bottom-right-radius: $sport-header-bet-top-id-border-radius;
    font-size: 0.8125rem;
    overflow: hidden;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 2px;
      background-color: $sport-header-bet-bottom-color-back;
    }

    &.colored {
      background-color: $sport-header-bet-top-id-color-back2;
    }
  }

  .bet-name {
    position: relative;
    height: 100%;
    padding-left: $sport-header-bet-top-id-width + 0.41667vw;
    padding-right: 4px;

    /deep/ &:before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      content: "";
      width: 20px;
      background: linear-gradient(to right,
        rgba($sport-header-bet-top-color-back, 0), $sport-header-bet-top-color-back);
      z-index: 1;
    }
  }
}

.width-large {
  .bet-id {
    width: $sport-header-bet-top-id-width-large;
  }

  .bet-name {
    padding-left: $sport-header-bet-top-id-width-large + 0.5208vw;
  }
}

.bet-header-bottom {
  height: $sport-header-bet-bottom-height;
  line-height: $sport-header-bet-bottom-height;
  font-size: 0.62rem;
  @if $sport-header-gradient == false {
    background-color: $sport-header-bet-bottom-color-back;
  }

  .outcome-name {
    float: left;
    width: 50%;
    height: 100%;
    color: $color-important-special;

    &.outcome-3 { width: 33.33%; }
  }
}
</style>
